<template>
  <v-card>
    <v-card-title style="display: flex; justify-content: center" class="mb-1">
      {{ employeed.fullName }}
    </v-card-title>
    <v-form
      @submit.prevent="submitForm"
      class="mx-4"
      ref="form"
      v-model="valid"
    >
      <v-alert
        dense
        v-if="error"
        color="red"
        elevation="5"
        outlined
        text
        type="error"
        align="center"
        class="mr-1 ml-1"
      >
        {{ alertValidate }}
      </v-alert>

      <v-autocomplete
        ref="deviceSelect"
        :items="this.devices"
        item-text="name"
        item-value="id"
        v-model="selectedItem"
        :label="$tc('enrollement.selectDevice')"
        :rules="rules"
        outlined
        dense
        @change="handleChange"
      />

      <v-slider
        v-model="quality"
        :label="$tc('enrollement.quality')"
        min="20"
        max="100"
        step="1"
        thumb-label="always"
        class="mt-4"
      />
      <v-card outlined>
        <v-card-title class="text-md-body-1">
          {{ $tc("enrollement.enrollFingerprint") }}
        </v-card-title>
        <v-container>
          <v-row class="pb-5">
            <v-col cols="3" class="mx-auto">
              <v-btn
                block
                @click="addFingerprint"
                class="mb-1"
                :disabled="fingerprints.length >= 10"
              >
                Agregar
              </v-btn>
              <div
                v-for="(fingerprint, index) in fingerprints"
                :key="index"
                cols="3"
              >
                <v-btn
                  @click="select(fingerprint, index)"
                  block
                  color="primary"
                  class="mb-1"
                  :class="selectedIndex === index ? 'selected' : ''"
                >
                  Huella {{ index + 1 }}
                </v-btn>
              </div>
            </v-col>

            <v-col class="pa-0 ma-0">
              <v-row class="pa-0 ma-0">
                <v-col cols="6">
                  <v-card
                    class="pa-2 d-flex justify-center align-center"
                    outlined
                  >
                    <v-img
                      v-show="image0 === null"
                      src="@/assets/fingerPrint.png"
                      width="100"
                      height="139"
                    />
                    <v-img v-show="image0" width="100" :src="image0" />
                  </v-card>
                </v-col>

                <v-col cols="6">
                  <v-card
                    class="pa-2 d-flex justify-center align-center"
                    outlined
                  >
                    <v-img
                      v-show="image1 === null"
                      src="@/assets/fingerPrint.png"
                      width="100"
                      height="139"
                    />
                    <v-img v-show="image1" :src="image1" width="100" />
                  </v-card>
                </v-col>
              </v-row>

              <v-row class="pa-0 ma-0 mx-3 justify-center">
                <v-card
                  outlined
                  :class="ScanningFlowColor"
                  v-show="ScanningFlowText"
                >
                  <v-card-text class="text-center">
                    {{ ScanningFlowText }}
                  </v-card-text>
                </v-card>
              </v-row>
            </v-col>

            <v-col cols="3">
              <v-btn
                block
                class="mb-1"
                @click="scanner()"
                :disabled="disabledScan()"
                >Escanear</v-btn
              >
              <v-btn
                block
                class="mb-1"
                @click="deleteFingerPrint()"
                :disabled="disabledDeleteAndValidate()"
                >Eliminar</v-btn
              >
              <!--
              [DESACTIVADA] Este boton ya no se usa pero puede llegar a necesitarse en un futuro.
              <v-btn
                block
                class="mb-1"
                @click="validationScan()"
                :disabled="disabledDeleteAndValidate()"
                >Validar</v-btn
              > -->
            </v-col>
          </v-row>
        </v-container>
      </v-card>
      <div class="d-flex justify-space-between py-4">
        <v-btn class="bt-exit" @click="cancel">{{
          $tc("editRegistrations.cancel")
        }}</v-btn>
        <v-btn type="submit" class="bt-acept ml-3" @click="confirm">
          {{ $tc("editRegistrations.acept") }}</v-btn
        >
      </div>
    </v-form>
    <Snackbar :alert="alert" :color="color" :textAlert="textAlert" />
  </v-card>
</template>

<script>
import Snackbar from "../../../components/Complement/Snackbar.vue";
import { getConfig } from "@/config";

export default {
  components: { Snackbar },
  props: {
    employeed: Object,
  },
  data() {
    return {
      valid: true,
      error: false,
      alertValidate: "",
      isChange: false,
      rules: [
        (v) =>
          (v !== null && v !== undefined && v !== "") ||
          this.$tc("editRegistrations.requerid"),
      ],
      selectedItem: null,
      quality: 80,
      fingerprints: [],
      selectedIndex: null,
      templateValidar: null,
      image0: null,
      image1: null,
      alert: false,
      textAlert: "",
      color: null,
      typeAction: "",
      template0: null,
      template1: null,
      ScanningFlowText: false,
      ScanningFlowColor: "",
      identified: false,
      _config: null,
    };
  },
  async mounted() {
    if (this.config.enroll === "suprema") {
      await this.$store.dispatch("employees/getInfoUser", this.employeed.empId);
      const templates = this.$store.state.employees.userFingerprintTemplates;
      this.loadFingerprints(templates);
      this.selectedItem = this.devices[0].id ? this.devices[0].id : null;
    }
  },
  computed: {
    config() {
      if (!this._config) {
        const cfg = getConfig();
        if (!cfg) throw new Error("Config not loaded");
        this._config = cfg;
      }
      return this._config;
    },
    scanFingerPrint() {
      return this.$store.state.employees.scanFingerPrint;
    },
    devices() {
      return this.$store.state.employees.devices;
    },
    usersSuprema() {
      return this.$store.state.employees.usersSuprema;
    },
  },
  methods: {
    /*
    // [DESACTIVADA] Esta función ya no se usa pero puede llegar a necesitarse en un futuro.
    async validationScan() {
      // Identificación
      this.identified = await this.$store.dispatch("employees/identifyScan",
        this.templateValidar.template0
      );
      this.ScanningFlowColor = "blue lighten-4";
      this.ScanningFlowText =
        this.$tc("enrollement.fingerprintAlreadyExists") +
        " para el empleado " +
        this.identified.matchedUser.name;
    },
    */
    showAlert(text, color) {
      this.alert = true;
      this.textAlert = text;
      this.color = color;

      setTimeout(() => {
        this.alert = false;
      }, 3000);
    },
    loadFingerprints(templates) {
      this.fingerprints = templates.slice(0, 10);
    },
    disabledScan() {
      if (this.selectedIndex === null) {
        return true;
      } else if (this.image0 !== null) {
        return true;
      } else {
        return false;
      }
    },
    disabledDeleteAndValidate() {
      if (this.selectedIndex === null) {
        return true;
      } else if (this.image0 === null) {
        return true;
      } else {
        return false;
      }
    },
    async verifyExistUser() {
      const empId = this.employeed.empId;

      if (this.usersSuprema.some((user) => Number(user.id) === empId)) {
        return;
      }

      /*
      ------[SE COMENTA PORQUE SE ASUME QUE SI USUARIO NO EXISTE EN SUPREMA NO SE VA A CREAR EN DS9]------
      this.$store.commit("employees/setNewUserSuprema", {
        name: this.employeed.fullName,
        user_id: empId,
        user_group_id: {
          id: 1,
          name: "all users",
        },
        disabled: "false",
        start_datetime: "2001-01-01T00:00:00.00Z",
        expiry_datetime: "2037-01-01T00:00:00.00Z",
      });

      await this.$store.dispatch("employees/addUserSuprema"); */
      await this.$store.dispatch("employees/getInfoUser", this.employeed.empId);
    },
    async scanner() {
      this.$refs.form.validate();
      if (this.selectedIndex !== null && this.selectedItem !== null) {
        try {
          this.typeAction = "add";
          this.ScanningFlowColor = "blue lighten-4";
          this.ScanningFlowText = this.$tc(
            "enrollement.placeYourFingerToBeScanned"
          );

          await this.$store.commit("employees/setFingerScan", {
            enrollQuality: this.quality,
            idDevice: this.selectedItem,
            rawImage: false,
          });

          // Escaneo 1
          this.$store
            .dispatch("employees/startScan")
            .then(async () => {
              this.template0 = this.scanFingerPrint.template0;
              // Identificación
              this.identified = await this.$store.dispatch(
                "employees/identifyScan",
                this.template0
              );
              this.ScanningFlowText = false;

              if (this.identified === false) {
                this.image0 =
                  "data:image/jpeg;base64," +
                  this.scanFingerPrint.template_image0;

                this.ScanningFlowColor = "blue lighten-4";
                this.ScanningFlowText = this.$tc(
                  "enrollement.placeYourFingerToBeScannedAgain"
                );
                // Escaneo 2
                this.$store
                  .dispatch("employees/startScan")
                  .then(async () => {
                    this.template1 = this.scanFingerPrint.template0;
                    this.image1 =
                      "data:image/jpeg;base64," +
                      this.scanFingerPrint.template_image0;
                    // Verificación
                    await this.$store
                      .dispatch("employees/verifyScan", {
                        template0: this.template0,
                        template1: this.template1,
                      })
                      .catch(() => {
                        this.typeAction = "";
                        this.image0 = null;
                        this.image1 = null;
                        this.ScanningFlowColor = "red lighten-4";
                        this.ScanningFlowText = this.$tc(
                          "enrollement.verifyError"
                        );
                      });
                  })
                  .catch(() => {
                    this.typeAction = "";
                    this.image0 = null;
                    this.ScanningFlowColor = "red lighten-4";
                    this.ScanningFlowText = this.$tc("enrollement.errorScan");
                  });
              } else {
                this.typeAction = "";
                this.ScanningFlowColor = "yellow lighten-3";
                this.ScanningFlowText =
                  this.$tc("enrollement.fingerprintAlreadyExists") +
                  " para el empleado " +
                  this.identified.matchedUser.name;
              }
            })
            .catch(() => {
              this.typeAction = "";
              this.ScanningFlowColor = "red lighten-4";
              this.ScanningFlowText = this.$tc("enrollement.errorScan");
            });
        } catch (e) {
          this.showAlert(this.$tc("enrollement.errorScan"), "#FF8D58");
        }
      }
    },
    deleteFingerPrint() {
      if (this.selectedIndex !== null) {
        this.fingerprints.splice(this.selectedIndex, 1);
        this.selectedIndex = null;
        this.typeAction = "delete";
      }
    },
    select(fingerprint, index) {
      this.templateValidar = fingerprint;
      this.selectedIndex = index;

      if (!fingerprint || Object.keys(fingerprint).length === 0) {
        this.image0 = null;
        this.image1 = null;
        return;
      }

      this.image0 = "data:image/jpeg;base64," + fingerprint.template_image0;
      this.image1 = "data:image/jpeg;base64," + fingerprint.template_image1;
    },
    addFingerprint() {
      if (this.fingerprints.length < 10) {
        this.fingerprints.push({});
      }
    },
    submitForm(e) {
      if (e) {
        e.preventDefault();
      }
    },
    handleSubmit(form) {
      const formData = new FormData(form);
      const itemsComplete = {};

      for (let [name, value] of formData) {
        itemsComplete[name] = value;
      }
      this.$refs.form.resetValidation();
      this.$emit("save", itemsComplete);
    },
    cancel() {
      this.$refs.form.resetValidation();
      this.$emit("cancel", false);
    },
    confirm() {
      if (this.config.enroll === "suprema") {
        this.verifyExistUser();

        if (this.typeAction === "add") {
          this.$store.dispatch("employees/editFingerprintToUser", {
            id: this.employeed.empId,
          });
          const form = this.$refs.form.$el;
          this.validation(form);
        } else if (this.typeAction === "delete") {
          this.$store.dispatch("employees/editFingerprintToUser", {
            id: this.employeed.empId,
            arrayModified: this.fingerprints,
          });
          const form = this.$refs.form.$el;
          this.validation(form);
        } else {
          this.ScanningFlowColor = "yellow lighten-3";
          this.ScanningFlowText = "Por favor, realize un escaneo";
        }
      }
    },
    validation(form) {
      let valid = this.$refs.form.validate();
      if (valid) {
        this.handleSubmit(form);
      } else {
        this.error = true;
        this.alertValidate = this.$tc("editRegistrations.required");
        setTimeout(() => {
          this.error = false;
        }, 2500);
      }
    },
    handleChange(selectedSelect) {
      this.$emit("select-updated", selectedSelect);
    },
  },
};
</script>
<style scoped>
.slider-input {
  display: flex !important;
  justify-content: center !important;
  align-items: flex-end !important;
}

.slider-container {
  border: 1px solid #959595;
  height: 90px;
}

.bt-exit {
  color: white !important;
  background-color: #e2504c !important;
}

.bt-acept {
  background-color: #77dd77 !important;
  color: white !important;
}

.small {
  font-size: x-large;
  align-content: center;
}
.selected {
  background-color: #295fb0 !important;
  color: white !important;
}
</style>
